import React from 'react';
import { Link } from 'react-router-dom';

const LoadService = (props) => {
	return (
		<Link to={`tel: ${props.si_tel}`} className='text-white'>
			<img className="" src="/img/fluent_call-20-regular.png" />
			전화
		</Link>
	);
}

export default LoadService;
